import type {
  ChatErrorBreadcrumb,
  ChatErrorReporter,
  TokenDiagnosticOutcome
} from '@/types/errorReporter';
import type { TokenRequestDiagnostics } from '@/utils/helpers/tokenResponseDiagnostics';

export type {
  ChatErrorBreadcrumb,
  ChatErrorBreadcrumbLevel,
  ChatErrorReporter,
  TokenDiagnosticOutcome
} from '@/types/errorReporter';

let errorReporter: ChatErrorReporter | null = null;

export const configureChatErrorReporter = (reporter: ChatErrorReporter | null): void => {
  errorReporter = reporter;
};

export const notifyError = (
  error: Error,
  context?: Record<string, unknown>
): void | Promise<void> => {
  try {
    const result = errorReporter?.captureException(error, context);

    return result instanceof Promise ? result.catch(() => undefined) : result;
  } catch (_reportingError) {
    return undefined;
  }
};

export const addErrorBreadcrumb = (breadcrumb: ChatErrorBreadcrumb): void => {
  try {
    errorReporter?.addBreadcrumb(breadcrumb);
  } catch (_reportingError) {
    // Error tracking must not break chat behavior.
  }
};

export const reportTokenRequestDiagnostic = (
  tokenRequest: TokenRequestDiagnostics,
  outcome: TokenDiagnosticOutcome
): void => {
  try {
    errorReporter?.captureTokenRequestDiagnostic(tokenRequest, outcome);
  } catch (_reportingError) {
    // Error tracking must not break chat authentication or recovery.
  }
};
